import { zDocument, expectType } from './model.js';
import { zUser } from './user.js';
import { z } from 'zod';
import { reverseKeys } from './util/reverseKeys.js';
export const BlockReasonsLookup = {
    offensive: 'Offensive Content',
    spam: 'Spam',
    other: 'Other',
    auto: 'Auto'
};
export const BlockStatusesLookup = {
    active: 'Active',
    inactive: 'Inactive',
    temporary: 'Temporary'
};
export const BlockReasonsEnum = z.nativeEnum(reverseKeys(BlockReasonsLookup));
export const BlockReasons = Object.keys(BlockReasonsLookup);
export const BlockStatusesEnum = z.nativeEnum(reverseKeys(BlockStatusesLookup));
export const BlockStatuses = Object.keys(BlockStatusesLookup);
export const zBlock = zDocument.extend({
    user: z.string(),
    userToBlock: z.string(),
    type: z.literal('block'),
    reason: BlockReasonsEnum,
    status: BlockStatusesEnum
});
export const zFullBlock = zDocument.extend({
    user: z.string(),
    userToBlock: zUser,
    type: z.literal('block'),
    reason: BlockReasonsEnum,
    status: BlockStatusesEnum
});
expectType({});
expectType({});
expectType({});
expectType({});
export const EmptyNewBlock = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'block',
    user: '',
    userToBlock: '',
    reason: 'other',
    status: 'active'
};
export const EmptyBlock = {
    ...EmptyNewBlock
};
